export default __webpack_public_path__ + "static/media/logoTwitter.e6f801d4.png";